var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.168,
    height: 18,
    viewBox: "0 0 17.168 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 17.168,
    height: 18,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M8.583,18a.5.5,0,0,1-.289-.093L6.187,16.374h-2.6a.49.49,0,0,1-.468-.34l-.8-2.478L.2,12.025a.489.489,0,0,1-.178-.548L.828,9l-.8-2.478A.489.489,0,0,1,.2,5.972L2.311,4.441l.8-2.478a.491.491,0,0,1,.468-.339h2.6L8.295.093a.492.492,0,0,1,.577,0l2.109,1.532h2.6a.49.49,0,0,1,.468.339l.8,2.478,2.108,1.531a.491.491,0,0,1,.179.549L16.34,9l.8,2.479a.488.488,0,0,1-.179.548l-2.108,1.532-.8,2.478a.493.493,0,0,1-.468.34h-2.6L8.872,17.907A.494.494,0,0,1,8.583,18ZM3.939,15.394H6.347a.478.478,0,0,1,.289.1L8.583,16.9l1.949-1.414a.482.482,0,0,1,.289-.1h2.408l.744-2.29a.494.494,0,0,1,.178-.245L16.1,11.444l-.744-2.29a.475.475,0,0,1,0-.3l.744-2.29L14.15,5.145a.5.5,0,0,1-.178-.245l-.744-2.29H10.821a.484.484,0,0,1-.289-.1L8.583,1.1l-1.349.98-.6.435a.489.489,0,0,1-.289.1H3.939L3.2,4.9a.5.5,0,0,1-.178.245L1.069,6.559l.744,2.29a.488.488,0,0,1,0,.3l-.744,2.29,1.949,1.414A.5.5,0,0,1,3.2,13.1Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M8.739,10.56a.491.491,0,0,1-.491-.491V5.163a.491.491,0,1,1,.981,0v4.907a.491.491,0,0,1-.491.491",
    transform: "translate(-0.154 -0.088)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M8.739,13.635a.491.491,0,0,1-.491-.491v-.981a.491.491,0,0,1,.981,0v.981a.491.491,0,0,1-.491.491",
    transform: "translate(-0.154 -0.219)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.0bdd34dcd70a03fe968fe693c246bd25.svg";
export { ForwardRef as ReactComponent };